import Vue from 'vue'
/* 局部引入 */
import {Button,Tag} from 'element-ui'
Vue.use(Button)
Vue.use(Tag)